/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DomainRecipientsIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M7.3,12.8l-1.7-1.7h2c0.1-0.4,0.1-0.7,0.1-1.1c0-0.6,0.2-0.7-0.3-1.1C7,8.5,6.8,8.3,6.9,7.9 c0.1-0.4,0.2-0.8,0.3-1c0.1-0.1,0.3-0.3,0.7-0.1C8.2,7,8.8,7.2,9.3,7.5c0.2,0.1,0.4,0.1,0.6,0.2V7V6h1H13c-0.3-3.4-3.1-6-6.5-6 C2.9,0,0,2.9,0,6.5C0,10.1,2.9,13,6.5,13c0.3,0,0.6,0,0.9-0.1L7.3,12.8z M4.2,5.5C3.7,5.1,3.5,4.7,3.4,4c0-0.3-0.4-0.8-0.7-1.2 c1-0.9,2.3-1.5,3.8-1.5c1.5,0,2.8,0.6,3.8,1.5C10.1,2.9,10.1,3,9.8,3.2C9.4,3.5,9.4,3.7,9.1,3.5C8.8,3.4,8.9,3.3,8.8,2.9 C8.6,2.5,8.5,2.5,8.2,2.3C7.8,2.2,7.6,2.1,7.3,1.9C6.9,1.7,6.8,2,6.6,2.1C6.3,2.2,6.1,2.4,6,3C5.8,3.6,6.4,3.3,6.7,3.3 C7.1,3.4,7.1,3.3,7.1,3c0-0.3-0.1-0.6,0.1-0.7c0.2-0.1,0.3,0.2,0.7,0.3c0.5,0.2,0.6,0.5,0.8,0.9C8.8,4,8.6,4,8.4,4.2 C8.2,4.4,8.2,4.3,7.7,4.4c-0.5,0-0.3,0.4-0.6,0.7s0.6-0.2,0.1,0.2C6.7,5.6,6.8,5.8,6.5,5.6c-0.3-0.2-0.3,0-0.7,0.1 C5.4,5.8,5.6,6.2,5.9,6.4c0.2,0.2,0.6,0.2,0.9,0.9C7,7.6,6.1,6.8,5.4,6.5C4.7,6.2,4.6,5.8,4.2,5.5z"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.6,10.4c-0.2,0.3-0.4,0.5-0.5,0.6h1.7V9.3C9.3,9.8,9,9.8,8.6,10.4z"/>
      <polygon fillRule="evenodd" clipRule="evenodd" points="12,16 8,12.1 10.9,12.1 10.9,7 13.1,7 13.1,12.1 16,12.1"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}
